module.exports = __webpack_public_path__ + "static/media/employee_experience_4.f2f19d17.png";